export class PictureTextSlider {
    constructor() {
        /*                   */
    }
}
